export default 
['katyperry',
'BarackObama',
'justinbieber',
'taylorswift13',
'ladygaga',
'TheEllenShow',
'jtimberlake',
'ArianaGrande',
'KimKardashian',
'realDonaldTrump',
'selenagomez',
'britneyspears',
'jimmyfallon',
'BillGates',
'JLo',
'nytimes',
'BrunoMars',
'KingJames',
'Oprah',
'MileyCyrus',
// 'SportsCenter',
'KevinHart4real',
'LilTunechi',
'wizkhalifa',
'Pink',
'aliciakeys',
'chrisbrown',
'kanyewest',
'ConanOBrien',
'KendallJenner',
'ActuallyNPH',
'KylieJenner',
'khloekardashian',
'pitbull',
'danieltosh',
'POTUS',
'elonmusk',
'HillaryClinton',
'kourtneykardash',
'Eminem',
'MariahCarey',
'blakeshelton',
'NICKIMINAJ',
'LeoDiCaprio',
'StephenAtHome',
// 'WhiteHouse',
'JimCarrey',
'aplusk',
'SnoopDogg',
'KDTrey5',
'ParisHilton',
'xtina',
'camerondallas',
'RyanSeacrest',
'ZacEfron',
'tomhanks',
'Diddy',
'POTUS44',
'Beyonce',
'Zendaya',
'SHAQ',
'maroon5',
'tyrabanks',
'BigSean',
'SethMacFarlane',
'kobebryant',
'nickjonas',
'TreySongz',
'funnyordie',
// 'voguemagazine',
// 'washingtonpost',
'TheRock',
// 'ObamaWhiteHouse',
'StephenCurry30',
'VancityReynolds',
'neiltyson',
'ashleytisdale',
'iamwill',
'stephenfry',
'RobertDowneyJr',
'SarahKSilverman',
'johnlegend',
'JColeNC',
'Usher',
'MichelleObama',
'kelly_clarkson',
'markiplier',
'mindykaling',
'FLOTUS',
'kendricklamar',
// 'enews',
'Ludacris',
'JohnCena',
'jimmykimmel',
'charliesheen',
// 'Starbucks',
'MarcAnthony',
'tim_cook',
// 'TheOnion',
'ciara',
'BillClinton',
'billmaher',
'chrissyteigen',
'serenawilliams',
'azizansari',
'Pharrell',
'ChrisEvans',
'VictoriaJustice',
'halsey',
'50cent']